module.exports = __webpack_public_path__ + "img/resource-tech-image-71.1db764fc.jpg";